import { DataCardDetailsEntry } from '@/components/card'
import { Column } from '@/components/table/base'
import { WebsocketCopyCell } from '@/components/table/cells/WebsocketCopyCell/WebsocketCopyCell'
import { EntryRow } from '@/stores/tournament/tournament.store'
import { GolfTournamentWithFeedCount } from '@/stores/tournaments/tournaments.utils'

const NA_VALUE = '-' as const

export const getTournamentHeaderItems = (
  currentTournament: GolfTournamentWithFeedCount | null | undefined
): DataCardDetailsEntry[] => {
  return [
    {
      key: 'Id',
      value: currentTournament?.id || NA_VALUE,
      copyable: true
    },
    {
      key: 'Start Date',
      value: currentTournament?.startDate || NA_VALUE
    },
    {
      key: 'End Date',
      value: currentTournament?.endDate || NA_VALUE
    },
    {
      key: 'Location',
      value: currentTournament?.venue || NA_VALUE
    },
    {
      key: 'UTC',
      value: currentTournament?.utcOffset || NA_VALUE
    },
    {
      key: 'Tournament Data Status',
      value: currentTournament?.tournamentDataStatus || NA_VALUE
    }
  ]
}

export const TOURNAMENT_ENTRY_LIST_TABLE_COLUMNS: Column<EntryRow>[] = [
  {
    type: 'text',
    id: 'teamNo',
    label: 'Team ID',
    sortAttribute: 'teamNo'
  },
  {
    type: 'text',
    id: 'players',
    label: 'Player(s)/Team',
    sortAttribute: 'players',
    transform: ([playerOne, playerTwo]) =>
      playerOne.displayName + (playerTwo?.displayName ? ' ' + playerTwo?.displayName : '')
  },
  {
    type: 'component',
    id: '$holeByHole',
    label: 'Hole By Hole',
    render: ({ wsDetails }) => (
      <WebsocketCopyCell status={wsDetails.holebyhole.status} copyText={wsDetails.holebyhole.url} />
    )
  },
  {
    type: 'component',
    id: '$roundDetails',
    label: 'Round Details',
    render: ({ wsDetails }) => (
      <WebsocketCopyCell
        status={wsDetails.rounddetails.status}
        copyText={wsDetails.rounddetails.url}
      />
    )
  },
  {
    type: 'component',
    id: '$playerstats',
    label: 'Player Stats',
    render: ({ wsDetails }) => (
      <WebsocketCopyCell
        status={wsDetails.playerstats.status}
        copyText={wsDetails.playerstats.url}
      />
    )
  }
]
